import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=b92c0daa&scoped=true"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=b92c0daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92c0daa",
  null
  
)

export default component.exports